import { computed, type Ref, unref } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import { GET_CUSTOM_FIELD_TEMPLATES } from '@/graphql/customFields';
import type { CustomFieldEntity } from '@/types/composition-functions';
import type { CustomFieldTemplateListQuery, CustomFieldTemplateListQueryVariables } from '@/types/operations';

/**
 * Ready-made custom field sets for one record type (#574), e.g. state of
 * origin and LGA for Nigerian schools. Needs Custom Fields → View.
 */
export function useCustomFieldTemplates(options: {
  entity: CustomFieldEntity | Ref<CustomFieldEntity>;
  enabled?: Ref<boolean>;
}) {
  const { result, loading, error, refetch } = useQuery<CustomFieldTemplateListQuery, CustomFieldTemplateListQueryVariables>(
    GET_CUSTOM_FIELD_TEMPLATES,
    () => ({ entity: unref(options.entity) }),
    () => ({ fetchPolicy: 'cache-and-network', enabled: options.enabled?.value ?? true }),
  );

  return {
    templates: computed(() => result.value?.customFieldTemplates ?? []),
    loading,
    error,
    refetch,
  };
}
